import * as React from 'react';

import { ReportsTableWrapper } from './ReportsTable';

export const Reports: React.FC = () => {
  return <ReportsTableWrapper />;
};
